/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { AdminAmenityDto, AdminAmenityRequestDto } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class AdminAmenityService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags AdminAmenityService
   * @name GetAmenity
   * @summary Get Amenity by ID
   * @request GET:/v1/admin/amenities/{amenityId}
   * @secure
   */
  getAmenity = (amenityId: number, params: RequestParams = {}) =>
    this.http.request<AdminAmenityDto, any>({
      path: `/v1/admin/amenities/${amenityId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminAmenityService
   * @name UpdateAmenity
   * @summary Update Amenity
   * @request PUT:/v1/admin/amenities/{amenityId}
   * @secure
   */
  updateAmenity = (amenityId: number, data: AdminAmenityRequestDto, params: RequestParams = {}) =>
    this.http.request<AdminAmenityDto, any>({
      path: `/v1/admin/amenities/${amenityId}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminAmenityService
   * @name DeleteAmenity
   * @summary Delete Amenity
   * @request DELETE:/v1/admin/amenities/{amenityId}
   * @secure
   */
  deleteAmenity = (amenityId: number, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/admin/amenities/${amenityId}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminAmenityService
   * @name GetAmenities
   * @summary Get Amenities
   * @request GET:/v1/admin/amenities
   * @secure
   */
  getAmenities = (
    query?: {
      searchKeyword?: string;
      /**
       * Zero-based page index (0..N)
       * @min 0
       * @default 0
       */
      page?: number;
      /**
       * The size of the page to be returned
       * @min 1
       * @default 20
       */
      size?: number;
      /** Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
      sort?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<AdminAmenityDto[], any>({
      path: `/v1/admin/amenities`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminAmenityService
   * @name CreateAmenity
   * @summary Create Amenity
   * @request POST:/v1/admin/amenities
   * @secure
   */
  createAmenity = (data: AdminAmenityRequestDto, params: RequestParams = {}) =>
    this.http.request<AdminAmenityDto, any>({
      path: `/v1/admin/amenities`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
